import type { MenuCategory } from "@/lib/api/types";

export const DUPLICATE_CATEGORY_NAME_ERROR = "A category with that name already exists";

export function isDuplicateCategoryName(
  name: string,
  categories: MenuCategory[],
  excludeId?: string
): boolean {
  return categories.some(
    (c) => c.id !== excludeId && c.name.trim().toLowerCase() === name.toLowerCase()
  );
}
